import React, { useState } from 'react';
import axiosInstance from '../../../utils/axiosInstance';

const DeleteProducts = ({ id, onDeleteSuccess }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    const shouldDelete = window.confirm('Are you sure you want to delete this product?');

    if (shouldDelete) {
      try {
        setIsDeleting(true);

        // Send the delete request to your API
        await axiosInstance.delete(`/api/products/deleteproduct/${id}`);

        // Handle successful deletion
        console.log('Product deleted successfully');

        // Notify the parent component about the deletion success
        if (onDeleteSuccess) {
          onDeleteSuccess();
        }

      } catch (error) {
        // Handle errors (e.g., show an error message)
        console.error('Error deleting product:', error);
      } finally {
        setIsDeleting(false);
      }
    }
  };

  return (
    <button onClick={handleDelete} disabled={isDeleting}>
      {isDeleting ? 'Deleting...' : 'Delete'}
    </button>
  );
};

export default DeleteProducts;
